import api from "../../../api/stock/_produits";

const state = () => ({
    medicaments: [],
    all_articles: [],
    prix_base_assur: 0,

    liste_articles: [],

    liste_medicaments_by_categorie: [],
});

// getters
const getters = {
    medicaments: (state) => {
        return state.medicaments
    },

    all_articles: (state) => {
        return state.all_articles
    },

    prix_base_assur: (state) => {
        return state.prix_base_assur
    },

    liste_articles: (state) => {
        return state.liste_articles
    },

    liste_medicaments_by_categorie: (state) => {
        return state.liste_medicaments_by_categorie;
    },
};
// mutations
const mutations = {
    SET_MEDICAMENTS(state, medicaments) {
        state.medicaments = medicaments
    },

    SET_ALL_ARTICLES(state, all_articles) {
        state.all_articles = all_articles
    },

    SET_PRIX_BASE_ASSUR(state, prix) {
        state.prix_base_assur = prix
    },

    SET_LISTE_ARTICLES(state, liste) {
        state.liste_articles = liste
    },

    SET_LISTE_MEDICAMENTS_BY_CATEGORIE(state, medicaments) {
        state.liste_medicaments_by_categorie = medicaments
    },
};

// actions
const actions = {

    postVenteSoinsEffectues({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.postVenteProduitsSoinsEffectues(data).then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getVentesExterne({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getVentesExterne(data).then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    
    storeVente({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storeVente(data).then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getMedicaments({ commit }) {
        api.getMedicaments().then(
            response => {
                commit('SET_MEDICAMENTS', response)
            }
        )
    },

    /**
     * Liste des articles
     */
    getAllArticles({ commit }) {
        api.allArticles().then(
            response => {
                commit('SET_ALL_ARTICLES', response)
            }
        )
    },

    getPrixBaseAssurance({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPrixBaseAssurance(data).then(
                response => {
                    commit('SET_PRIX_BASE_ASSUR', response)
                    resolve(response)

                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeArticles({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeArticles().then(
                response => {
                    commit('SET_LISTE_ARTICLES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeMedicamentsParCategorie({commit}, data){
        return new Promise((resolve,reject) => {
            api.getListeMedicamentsParCategorie(data).then(
                response => {
                    commit('SET_LISTE_MEDICAMENTS_BY_CATEGORIE', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};